import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import documentTemplateKeys from '@/api/queries/documentTemplates/keyFactory';
import { graphql } from '@/gql';
import { DocumentTemplateAvailableVariablesInput } from '@/gql/graphql';

const GET_DOCUMENT_TEMPLATE_AVAILABLE_VARIABLES = graphql(`
  query GetDocumentTemplateAvailableVariables(
    $input: DocumentTemplateAvailableVariablesInput!
  ) {
    documentTemplateAvailableVariables(input: $input) {
      __typename
      schema
    }
  }
`);

export const useGetDocumentTemplateAvailableVariables = (
  input: DocumentTemplateAvailableVariablesInput
) => {
  return useQuery({
    queryKey: documentTemplateKeys.documentTemplateVariables(input),
    queryFn: () => {
      return gqlClient.request(GET_DOCUMENT_TEMPLATE_AVAILABLE_VARIABLES, {
        input,
      });
    },
  });
};
